import { useContext } from 'react';
import Summary from '../../../ui-components/Summary';
import { giftcardState } from '../client-state/giftcard-state-context';
import useLocalize from '../../../Hooks/useLocalize';
import { Row } from '../../../SubComponents/Modals';
import { Text } from '../../../SubComponents/Text';
import { formatDuration } from '../../../Utils/utils';
import useLocale from '../../../Hooks/use-locale';
import localizations from '../../../localizations';
import useFormatPrice from '../../../Hooks/use-format-price';
import useGiftcardPrices from '../../../Hooks/use-giftcard-prices';
import { paymentReducerActionTypes } from '../../../redusers/payment-reducer';
import { isSummaryOpenActionTypes } from '../../../redusers/is-summary-open-reducer';
import useGiftcardMinimalShop from '../server-data/use-giftcard-minimal-shop';
import useGiftcardShop from '../server-data/use-giftcard-shop';

interface SummaryWithDataProps {
  closeable: boolean;
}

const SummaryWithData = (props: SummaryWithDataProps) => {
  const { data: minimalShop } = useGiftcardMinimalShop();
  const { data: shop } = useGiftcardShop();
  const { state, dispatch } = useContext(giftcardState);
  const localize = useLocalize();
  const { languageAsEnum } = useLocale();
  const localization = localizations[languageAsEnum];
  const formatPrice = useFormatPrice();
  const { giftcardPrices } = useGiftcardPrices();

  const summaryDurationString = shop?.configuration?.hideGiftCardDurations
    ? ''
    : ` • ${formatDuration(state.giftcard.duration, { localization })}`;

  return (
    <Summary
      closable={props.closeable}
      heading={localize('product.yourGiftcard')}
      shopName={minimalShop?.name || localize('product.noLocationSelected')}
      prices={giftcardPrices}
      vouchers={state.vouchers}
      payments={state.payment.payments}
      onClose={() => {
        dispatch({ type: isSummaryOpenActionTypes.SET_IS_OPEN, payload: false });
        dispatch({
          type: paymentReducerActionTypes.UPDATE_SHOW_PAYMENT_MODAL,
          payload: false,
        });
      }}
    >
      <Row justifyContent="space-between" mb="2">
        <Text color="#fff">
          {state.giftcard.campaignName
            ? state.giftcard.campaignName
            : `${localize('product.Giftcard')}${summaryDurationString}`}
        </Text>

        <Text color="#fff">
          {giftcardPrices?.rentalPrice || giftcardPrices?.rentalPrice === 0
            ? formatPrice(giftcardPrices.rentalPrice)
            : '-'}
        </Text>
      </Row>
    </Summary>
  );
};

export default SummaryWithData;
